export default __webpack_public_path__ + "static/media/kiepsat.e5604c33.png";